import React from 'react';
import ProjectItem from '../components/ProjectItem';

import {projectList} from '../utils/ProjectList';


import '../styles/Projects.css';

function Projects(props) {
    return (
        <div className="projects">
            <h1>Personal Projects</h1>
            <div className="projectList">
            {projectList.map((project,index)=>{
                return <ProjectItem id={index} name={project.name} image={project.image}/>
            })}

            </div>
        </div>
    );
}

export default Projects;